require(
      "!../../../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../../../node_modules/json-loader/index.js!./es-articles-ball-state-financial-opens-next-generation-banking-center.json") })
        }
      }, "path---es-articles-ball-state-financial-opens-next-generation-banking-center");
     }
    


//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/gatsby-module-loader?name=path---es-articles-ball-state-financial-opens-next-generation-banking-center!./.cache/json/es-articles-ball-state-financial-opens-next-generation-banking-center.json
// module id = 2035
// module chunks = 231608221292675